
import { mapActions } from 'vuex';
import OrderCard from '@/components/OrderCard.vue';

export default {
  name: 'ProductList',
  props: ['listings', 'isDark'],
  data() {
    return {
      notification: null,
    }
  },
  methods: {
    
  },
  components: {
    OrderCard
  }
}
